/**
 * Lightweight text metrics for durable file rows. Kept local to the supabase
 * package so platform code does not depend on service-core.
 */
export type FileContentStats = {
  wordCount: number;
  charCount: number;
  charCountNoSpaces: number;
};

export function fileContentStats(
  text: string | null | undefined,
): FileContentStats {
  const normalized = String(text ?? '').trim();
  const words = normalized ? normalized.split(/\s+/).filter(Boolean).length : 0;
  return {
    wordCount: words,
    charCount: normalized.length,
    charCountNoSpaces: normalized.replace(/\s/g, '').length,
  };
}
